import { render, staticRenderFns } from "./historialConsultas.vue?vue&type=template&id=c798a534&scoped=true&"
import script from "./historialConsultas.vue?vue&type=script&lang=js&"
export * from "./historialConsultas.vue?vue&type=script&lang=js&"
import style0 from "./historialConsultas.vue?vue&type=style&index=0&id=c798a534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c798a534",
  null
  
)

export default component.exports